module.exports = __webpack_public_path__ + "assets/svg/UI/close-348510.svg";